export const sumStringLength = (inputValues) => {
    return inputValues.reduce((acc, cur) => acc + (cur || '').length, 0);
};
